import React from 'react';
const PageContext = React.createContext<any>({
    setTimeshiftMilliseconds: () => {},
    updateTenantName: () => {},
});
export default PageContext;